import React from "react";

const FormFooter = ({ children }: any) => {
  return (
    <div className="panel-footer " style={{ textAlign: "center" }}>
      {children}
    </div>
  );
};

export default FormFooter;
